import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfirmationDialogComponent } from './confirmation-dialog/confirmation-dialog.component';
import { InformationDialogComponent } from './information-dialog/information-dialog.component';
import { DialogService } from './dialog.service';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogModule
  ],
  declarations: [
    ConfirmationDialogComponent,
    InformationDialogComponent
  ],
  exports: [
    ConfirmationDialogComponent,
    InformationDialogComponent
  ],
  providers: [
    DialogService
  ]
})

export class DialogModule {

}
